/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { hooks, unstable } from '@broadleaf/admin-components';
import { connect as connectFormik } from 'formik';
import PropTypes from 'prop-types';

import { SecondaryAction } from 'app/paypal/components/PayPalView/elements';

import messages from './UnlinkAccount.messages';

const { useCancelTokenFactory } = hooks;
const { useFormatMessage } = unstable;

/**
 * Component that renders the update action. By default it will request a link
 * to the PayPal dashboard and redirect the user to there.
 *
 * @author Nathan Moore (nathandmoore)
 */
const UnlinkAccount = ({ disabled = false, formik, payPalApi, state }) => {
  const formatMessage = useFormatMessage();
  const [getCancelToken] = useCancelTokenFactory();

  return (
    <SecondaryAction
      disabled={disabled || state.isFetching}
      onClick={async () => {
        await payPalApi.accounts.unlink({
          cancelToken: getCancelToken()
        });
        formik.setFieldValue('value', '');
      }}
    >
      {formatMessage(messages.updateAccountLabel)}
    </SecondaryAction>
  );
};

UnlinkAccount.propTypes = {
  /** ID of the account to update */
  accountId: PropTypes.string.isRequired,
  /** Whether the button should be disabled */
  disabled: PropTypes.bool,
  /** Interface for interacting with the PayPal API */
  payPalApi: PropTypes.shape({
    accounts: PropTypes.shape({
      update: PropTypes.func.isRequired
    }).isRequired
  }).isRequired
};

export default connectFormik(UnlinkAccount);
export { UnlinkAccount };
